import script from "./AdminGeneralManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminGeneralManager.vue?vue&type=script&setup=true&lang=ts"

import "./AdminGeneralManager.vue?vue&type=style&index=0&id=f8bf8f2a&scoped=true&lang=css"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f8bf8f2a"]])

export default __exports__